module.exports = __webpack_public_path__ + "static/about_bg-52a43a73fcf9b7994a4157d90520df60.jpg";